import { render, staticRenderFns } from "./password-change.vue?vue&type=template&id=37c405d7"
import script from "./password-change.vue?vue&type=script&lang=js"
export * from "./password-change.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports